import { Injectable } from '@angular/core';
import { BlockUIService } from 'ng-block-ui';

@Injectable()
export class UIBlockingService {

  readonly blockUIInstanceName = 'app-main';
  blockCount = 0;

  constructor(private blockUI: BlockUIService) { }

  public start(): void {
    this.blockCount += 1;
    // console.log('UI block count:', this.blockCount);
    if (this.blockCount === 1) {
      // console.log('Start UI blocking');
      this.blockUI.start(this.blockUIInstanceName);
    }
  }

  public stop(): void {
    if (this.blockCount <= 0) {
      // oops
      console.error('UIBlockingService: stop called when UI not blocked');
      return;
    }
    this.blockCount -= 1;
    // console.log('UI block count:', this.blockCount);
    if (this.blockCount === 0) {
      // console.log('Stop UI blocking');
      this.blockUI.stop(this.blockUIInstanceName);
    }
  }
}
